import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { CropFamic } from '@/types/Component';


@Component({
    components: {
        Modal
    }
})
export default class SelectCropFamicModal extends Vue {
    // 品目一覧取得
    private cropsFamic: CropFamic[] = []
    // 左索引
    private firstCutoutChar: string[] = []
    // 上段索引
    private upperIndexes: string[] = []
    private choiseFirstCutoutCharStr: string | string[] = ''
    // 品目選択モーダル
    latestCheckedCropsFamic: CropFamic = {
        id: '',
        name: '',
        hiragana: ''
    }
    // 品目頭文字リスト
    private cropsFamicInitialLines = [
        'アイウエオ',
        'カキクケコ',
        'ガギグゲゴ',
        'サシスセソ',
        'ザジズゼゾ',
        'タチツテト',
        'ダヂヅデド',
        'ナニヌネノ',
        'ハヒフヘホ',
        'バビブベボ',
        'パピプペポ',
        'マミムメモ',
        'ヤユヨ',
        'ラリルレロ',
        'ワヲン'
    ]

    @Prop()
    private value!: boolean

    @Prop()
    private checkedCropFamic!: CropFamic

    @Prop()
    private seedlingId!: string 



    get showCropsFamicModal(): boolean {
        return this.value
    }

    set showCropsFamicModal(value: boolean) {
        this.value
    }

    @Watch('showCropsFamicModal')
    private onChangeShowCropFamicModal() {
        this.getCropsFamicList()
    }

    // 品目一覧取得
    private getCropsFamicList() {
        this.cropsFamic = []
        const firstCharSet: Set<string> = new Set()
        this.$apiClient.doRequest('get', `/crops/crops_famic?seedling_id=${this.seedlingId}`).then((res)=>{
            this.cropsFamic = res.cropsFamic?.map((item: CropFamic) => ({
                ...item,
                hiragana: this.toKatakana(item.hiragana)
            }));
            this.cropsFamic.forEach((item: CropFamic) => {
                firstCharSet.add(item.hiragana.charAt(0))
            });
            this.firstCutoutChar = Array.from(firstCharSet).sort();
            // 上段索引は「あ」段のみ
            const initialLines = this.cropsFamicInitialLines.map(line => this.toKatakana(line))
            .filter(initialLine => this.firstCutoutChar.find(char => initialLine.includes(char)))
            this.upperIndexes = initialLines.map(line => line[0])

            this.latestCheckedCropsFamic = {
                ...this.checkedCropFamic,
                hiragana: this.toKatakana(this.checkedCropFamic?.hiragana || '')
            }
            const isUnset = this.checkedCropFamic?.name === '';
            if (isUnset) {
                this.latestCheckedCropsFamic = this.checkedCropFamic
                this.choiseFirstCutoutCharStr = 'ア';
            } else if (this.checkedCropFamic?.hiragana) {
                this.choiseFirstCutoutCharStr = this.toKatakana(this.checkedCropFamic.hiragana).charAt(0);
            } else {
                this.choiseFirstCutoutCharStr = this.firstCutoutChar[0];
            }
        })
    }

    private choiseFirstCutoutCharList(cropFamicName: string) {
        const katakanaName = this.toKatakana(cropFamicName)
        const str = this.cropsFamicInitialLines.find(initialLine => initialLine.includes(katakanaName))
        if (str) {
            this.choiseFirstCutoutCharStr = str.split('')
        }
    }

    private choiseFirstCutoutChar(cropFamicName: string) {
        this.choiseFirstCutoutCharStr = cropFamicName
    }

    private isDisplayCropsNameUpper(name: string) {
        const str = this.cropsFamicInitialLines.find(initialLine => initialLine.includes(name))
        if(typeof this.choiseFirstCutoutCharStr === 'string') {
            return str && str.indexOf(this.choiseFirstCutoutCharStr) > -1
        } else {
            return this.choiseFirstCutoutCharStr.includes(name)
        }
    }

    private isDisplayCropsName(name: string){
        if(typeof this.choiseFirstCutoutCharStr === 'string') {
            return this.choiseFirstCutoutCharStr === name
        } else {
            return this.choiseFirstCutoutCharStr.includes(name)
        }
    }

    private filteredCrops(): CropFamic[] {
        if(typeof this.choiseFirstCutoutCharStr === 'string') {
            return this.cropsFamic.filter(c => c.hiragana.charAt(0) === this.choiseFirstCutoutCharStr).sort(this.sortByHiragana)
        } else {
            return this.cropsFamic.filter(c => this.choiseFirstCutoutCharStr.includes(c.hiragana.charAt(0))).sort(this.sortByHiragana)
        }
    }

    private sortByHiragana(cropFamic1: CropFamic, cropfamic2: CropFamic): number {
        return cropFamic1.hiragana > cropfamic2.hiragana
            ? 1
            : cropFamic1.hiragana === cropfamic2.hiragana
                ? 0
                : -1
    }

    @Emit('save')
    private save() {
        return this.latestCheckedCropsFamic
    }

    @Emit('cancel')
    private cancel() {
        this.latestCheckedCropsFamic = {
            id: '',
            name: '',
            hiragana: ''
        }
        if(this.checkedCropFamic){
            this.choiseFirstCutoutCharStr = this.checkedCropFamic.hiragana.charAt(0)
        } else {
            this.choiseFirstCutoutCharStr = this.firstCutoutChar[0]
        }
        this.showCropsFamicModal = false
    }

    private toKatakana(str: string): string {
        return str.replace(/[\u3041-\u3096]/g, (ch) =>
            String.fromCharCode(ch.charCodeAt(0) + 0x60)
        );
    }
    
}